import { useEffect, useRef } from 'react';
import { UF_WIZARD_STEP } from '../../../utils/ufAttributeFormUtils';

/** Duración del resaltado de la UF recién creada al volver al listado (ms). */
export const UNIT_HIGHLIGHT_MS = 2400;

/** Fondo temporal para la card de la UF recién creada. */
export const UNIT_HIGHLIGHT_SX = {
  bgcolor: 'rgba(255,255,255,0.10)',
  boxShadow: 'inset 3px 0 0 rgba(255,255,255,0.65)',
  transition: 'background-color 0.4s, box-shadow 0.4s',
};

export const isHighlightedUnit = (highlightUnitId, unitId) => (
  highlightUnitId != null && unitId != null && String(highlightUnitId) === String(unitId)
);

/** Scroll suave a la card cuando queda resaltada. */
export const useScrollIntoViewWhen = (active) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!active || !ref.current || typeof ref.current.scrollIntoView !== 'function') return;
    ref.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [active]);
  return ref;
};

/**
 * ¿El guardado vuelve al listado de UF (tab Unidades Funcionales)?
 * - `finalSave`: botón «Guardar» del form, en alta (paso Características) o en la
 *   edición de una UF existente (dueño, invitado o editor de lista; cualquier origen).
 * - Compat: alta del wizard que llega al Guardar final (`createdInWizard` en el paso
 *   Características) aunque no venga `finalSave`.
 * - Nunca en guardados parciales (`partialStep`, p. ej. el borrador del paso 1) ni en
 *   el «Continuar» del paso Publicación, ni si no hay listado al que volver.
 * @param {{ finalSave?: boolean, createdInWizard?: boolean, partialStep?: string|null, hasListAfterSave?: boolean, wizardStep?: number }} options
 * @returns {boolean}
 */
export const shouldLeaveToUnitListAfterSave = ({
  finalSave = false,
  createdInWizard = false,
  partialStep = null,
  hasListAfterSave = false,
  wizardStep = null,
} = {}) => {
  if (partialStep || !hasListAfterSave) return false;
  if (finalSave) return true;
  return Boolean(createdInWizard) && wizardStep === UF_WIZARD_STEP.ATTRIBUTES;
};
